{
  "performance.title": "الأداء",
  "performance.period": "{start} – {end}",
  "performance.people.search": "ابحث عن زميل",
  "performance.people.empty": "لا يوجد أحد بهذا الاسم.",
  "performance.noAccess.title": "إدارة الأداء من صلاحيات الموارد البشرية",
  "performance.noAccess.body": "إدارة دورات التقييم والمعايرة والنماذج تحتاج صلاحية «إدارة الأداء». اطلبها من مسؤول النظام لو محتاجها.",
  "performance.notAvailable.title": "الصفحة دي مش متاحة",
  "performance.notAvailable.body": "يا إما مش موجودة، يا إما مش مشتركة معاك.",
  "performance.autosave.saving": "جارٍ الحفظ…",
  "performance.autosave.saved": "تم الحفظ",
  "performance.autosave.failed": "لم يتم الحفظ",
  "performance.rating.1": "يحتاج إلى تحسين",
  "performance.rating.2": "أقل من المتوقع",
  "performance.rating.3": "يحقق المتوقع",
  "performance.rating.4": "يفوق المتوقع",
  "performance.rating.5": "متميز",
  "performance.rating.option": "{number} – {label}",
  "performance.rating.outOf": "{number} من {total}",
  "performance.rating.none": "لا يوجد تقييم بعد",
  "performance.cycle.status.draft": "مسودة",
  "performance.cycle.status.active": "جارية",
  "performance.cycle.status.calibration": "المعايرة",
  "performance.cycle.status.published": "منشورة",
  "performance.cycle.status.closed": "مغلقة",
  "performance.review.status.pending": "لم يُرسل بعد",
  "performance.review.status.submitted": "تم الإرسال",
  "performance.review.status.declined": "تم الاعتذار",
  "performance.review.kind.self": "تقييم ذاتي",
  "performance.review.kind.manager": "تقييم المدير",
  "performance.review.kind.peer": "تقييم الزملاء",
  "performance.review.kind.upward": "تقييم المرؤوسين للمدير",
  "performance.review.kindShort.self": "ذاتي",
  "performance.review.kindShort.manager": "المدير",
  "performance.review.kindShort.peer": "الزملاء",
  "performance.review.kindShort.upward": "المرؤوسين",
  "performance.review.anonymous": "بدون اسم",
  "performance.growth.title": "التطوير والأداء",
  "performance.growth.nav.label": "أقسام التطوير والأداء",
  "performance.growth.nav.reviews": "التقييمات",
  "performance.growth.nav.goals": "الأهداف",
  "performance.growth.nav.meetings": "الاجتماعات الفردية",
  "performance.growth.nav.feedback": "الآراء والإشادات",
  "performance.growth.nav.team": "فريقي",
  "performance.reviews.toWrite": "تقييمات مطلوبة منك",
  "performance.reviews.toWriteHint": "تقييمك الذاتي والتقييمات اللي بتكتبها لزمايلك، مرتبة حسب دورة التقييم. المسودة بتتحفظ وأنت بتكتب.",
  "performance.reviews.loadError": "معرفناش نحمّل تقييماتك",
  "performance.reviews.empty.title": "مفيش تقييمات مطلوبة منك",
  "performance.reviews.empty.body": "لما الموارد البشرية تطلق دورة تقييم، التقييمات المطلوبة منك هتظهر هنا.",
  "performance.reviews.due": "آخر موعد {date}",
  "performance.reviews.openCount": "{count, plural, zero {لا شيء مطلوب} one {تقييم واحد مطلوب} two {تقييمان مطلوبان} few {# تقييمات مطلوبة} many {# تقييمًا مطلوبًا} other {# تقييم مطلوب}}",
  "performance.reviews.allDone": "خلصت كله",
  "performance.reviews.writingClosed": "الكتابة مقفولة",
  "performance.reviews.yourSelfReview": "تقييمك الذاتي",
  "performance.form.documentTitle": "كتابة تقييم",
  "performance.form.back": "كل التقييمات",
  "performance.form.loadError": "معرفناش نحمّل التقييم ده",
  "performance.form.title.self": "تقييمك الذاتي",
  "performance.form.title.manager": "تقييمك لـ{name}",
  "performance.form.title.peer": "تقييم زميل: {name}",
  "performance.form.title.upward": "تقييم المرؤوسين للمدير: {name}",
  "performance.form.about.self": "راجع شغلك في الفترة دي. مديرك والموارد البشرية هيقروه بعد ما ترسله.",
  "performance.form.about.manager": "تقييمك هو اللي بيحدد نتيجة {name}. هيقرأ تقييمك بعد ما الموارد البشرية تنشر النتائج.",
  "performance.form.about.peer": "{name} هيشوف آراء الزملاء من غير أسماء: متوسط التقييم والتعليقات بس. مديره والموارد البشرية بيشوفوا مين كتب إيه.",
  "performance.form.about.upward": "قول لـ{name} رأيك في إدارته ليك: إيه اللي بيساعدك، وإيه اللي ممكن يبقى أحسن.",
  "performance.upward.title": "إجاباتك بدون اسم",
  "performance.upward.promise": "{name} مش هيشوف اسمك أبدًا. هيشوف بس المتوسطات والتعليقات، وده بعد ما ٣ من فريقه على الأقل يجاوبوا.",
  "performance.form.required": "مطلوب",
  "performance.form.optional": "اختياري",
  "performance.form.rateThis": "اختار تقييم للسؤال ده.",
  "performance.form.comment": "تعليق (اختياري)",
  "performance.form.commentPlaceholder": "مثال من الشغل بيفرق جدًا.",
  "performance.form.answer": "إجابتك",
  "performance.form.answerPlaceholder": "اكتب إجابتك…",
  "performance.form.answered": "تمت الإجابة على {done} من {total}",
  "performance.form.submit": "إرسال التقييم",
  "performance.form.submitting": "جارٍ الإرسال…",
  "performance.form.submitTitle": "تبعت التقييم؟",
  "performance.form.submitBody.self": "مش هتقدر تعدّل إجاباتك بعد الإرسال. مديرك والموارد البشرية هيقروها.",
  "performance.form.submitBody.manager": "مش هتقدر تعدّل إجاباتك بعد الإرسال. {name} هيقرأها بعد نشر النتائج.",
  "performance.form.submitBody.peer": "مش هتقدر تعدّل إجاباتك بعد الإرسال. {name} هيشوفها من غير اسمك.",
  "performance.form.submitBody.upward": "مش هتقدر تعدّل إجاباتك بعد الإرسال، وهتفضل بدون اسم.",
  "performance.form.submitted": "تم إرسال التقييم. شكرًا ليك!",
  "performance.form.incompleteTitle": "فيه أسئلة لسه محتاجة تقييم",
  "performance.form.incompleteBody": "{count, plural, zero {قيّم الأسئلة المحددة تحت وابعت تاني.} one {قيّم السؤال المحدد تحت وابعت تاني.} two {قيّم السؤالين المحددين تحت وابعت تاني.} few {قيّم الـ# أسئلة المحددة تحت وابعت تاني.} many {قيّم الـ# سؤالًا المحددة تحت وابعت تاني.} other {قيّم الـ# سؤال المحددة تحت وابعت تاني.}}",
  "performance.form.conflictTitle": "التقييم ده اتعدّل من مكان تاني",
  "performance.form.conflictBody": "اتحفظ من تاب أو شاشة تانية. اعمل تحديث وكمّل من آخر إجابات.",
  "performance.form.reload": "تحديث",
  "performance.form.decline": "اعتذار",
  "performance.form.declineTitle": "تعتذر عن التقييم ده؟",
  "performance.form.declineBody": "قول ليه مش هتقدر تقيّم {name}، زي إنكم ما اشتغلتوش مع بعض في الفترة دي. الموارد البشرية هتشوف السبب.",
  "performance.form.declined": "تم الاعتذار عن التقييم.",
  "performance.form.closed.submittedTitle": "تم الإرسال",
  "performance.form.closed.submitted": "أرسلت التقييم ده يوم {date}.",
  "performance.form.closed.declinedTitle": "اعتذرت عن التقييم ده",
  "performance.form.closed.writingTitle": "الكتابة مقفولة",
  "performance.form.closed.writing": "الدورة دي مبقتش بتستقبل تقييمات. كلّم الموارد البشرية لو لسه محتاج ترسل.",
  "performance.results.mine": "نتائجك",
  "performance.results.mineHint": "النتائج المنشورة من دورات التقييم اللي اتقيّمت فيها.",
  "performance.results.loadError": "معرفناش نحمّل النتائج",
  "performance.results.empty.title": "مفيش نتائج لسه",
  "performance.results.empty.body": "لما الموارد البشرية تنشر دورة اتقيّمت فيها، نتيجتك هتظهر هنا.",
  "performance.results.acknowledged": "تم الاطلاع",
  "performance.results.toAcknowledge": "اقرأ وأكّد الاطلاع",
  "performance.results.documentTitle": "نتائج التقييم",
  "performance.results.yours": "نتائجك",
  "performance.results.theirs": "نتائج {name}",
  "performance.results.manager": "المدير: {name}",
  "performance.results.finalRating": "النتيجة النهائية",
  "performance.results.noFinal": "لا توجد نتيجة نهائية بعد",
  "performance.results.acknowledge": "اطلعت على تقييمي",
  "performance.results.acknowledgeHint": "اقرأ تقييمك وبعدين أكّد إنك اطلعت عليه. التأكيد مش معناه إنك موافق.",
  "performance.results.acknowledgedToast": "شكرًا إنك اطلعت على تقييمك.",
  "performance.results.acknowledgedOn": "تم الاطلاع يوم {date}",
  "performance.results.notAcknowledged": "لم يتم الاطلاع بعد.",
  "performance.results.notPublished": "النتائج لسه ما اتنشرتش، فالموظف مش هيقدر يشوفها.",
  "performance.results.comparison": "التقييم الذاتي وتقييم المدير",
  "performance.results.comparisonHint": "سؤال بسؤال، جنب بعض.",
  "performance.results.notSubmitted": "لم يُرسل",
  "performance.results.noAnswer": "لا توجد إجابة",
  "performance.results.noReviews.title": "مفيش تقييمات اتبعتت لسه",
  "performance.results.noReviews.body": "التقييم الذاتي وتقييم المدير هيظهروا هنا بعد إرسالهم.",
  "performance.results.peers": "رأي الزملاء",
  "performance.results.peersHint": "من غير أسماء: متوسط التقييم وكل التعليقات لكل سؤال.",
  "performance.results.peersNamedHint": "تقييم كل زميل باسمه. الموظف نفسه بيشوفها كمتوسطات من غير أسماء بس.",
  "performance.results.average": "المتوسط",
  "performance.results.answer": "الإجابة",
  "performance.upward.sectionTitle": "تقييم المرؤوسين للمدير",
  "performance.upward.sectionHint": "رأي فريق المدير فيه، من غير ما يظهر مين قال إيه.",
  "performance.upward.notEnoughTitle": "الإجابات لسه مش كفاية",
  "performance.upward.waiting": "وصل {done} من {total} إجابات لحد دلوقتي. الإجابات بتظهر بس لما {total} على الأقل يجاوبوا، عشان محدش يتعرف من إجابته.",
  "performance.upward.visible": "جاوب {done} أشخاص. بتظهر كمتوسطات وتعليقات بس.",
  "performance.goals.title": "الأهداف",
  "performance.goals.hint": "اللي بتسعى له في الفترة دي، وبيتقاس بالنتائج الرئيسية. حدّث التقدم أول بأول.",
  "performance.goals.viewLabel": "أهداف مين",
  "performance.goals.view.mine": "أهدافي",
  "performance.goals.view.company": "أهداف الشركة",
  "performance.goals.new": "هدف جديد",
  "performance.goals.newCompany": "هدف جديد للشركة",
  "performance.goals.loadError": "معرفناش نحمّل الأهداف",
  "performance.goals.empty.title": "مفيش أهداف لسه",
  "performance.goals.empty.body": "حط هدف للفترة دي وضيف نتائج رئيسية تقيسه بيها.",
  "performance.goals.companyEmpty.title": "مفيش أهداف للشركة لسه",
  "performance.goals.companyEmpty.body": "لما الموارد البشرية تحط أهداف الشركة، هتشوفها هنا مع الأهداف اللي بتدعمها.",
  "performance.goals.treeHint": "أهداف الشركة، وتحت كل هدف أهدافك اللي بتدعمه.",
  "performance.goals.treeLabel": "ترابط الأهداف",
  "performance.goals.company": "الشركة",
  "performance.goals.finished": "اتحققت أو اتلغت",
  "performance.goals.noKeyResults": "مفيش نتائج رئيسية: التقدم بيتحدد يدويًا.",
  "performance.goals.checkIn": "تحديث التقدم",
  "performance.goals.edit": "تعديل الهدف",
  "performance.goals.back": "كل الأهداف",
  "performance.goals.progressLabel": "تم إنجاز {percent}",
  "performance.goals.progressOf": "{title}: تم إنجاز {percent}",
  "performance.goals.krValue": "{number} / {total} {label}",
  "performance.goals.krProgress": "{title}: {percent}",
  "performance.goals.krRange": "من {start} إلى {end} {label}",
  "performance.goals.supports": "بيدعم",
  "performance.goals.supportedBy": "بتدعمه",
  "performance.goals.supportedByHint": "الأهداف اللي بتصب في الهدف ده.",
  "performance.goals.created": "تمت إضافة الهدف.",
  "performance.goals.saved": "تم حفظ الهدف.",
  "performance.goals.checkedIn": "تم تحديث التقدم.",
  "performance.goals.checkInTitle": "تحديث التقدم",
  "performance.goals.checkInSave": "حفظ التحديث",
  "performance.goals.checkInNote": "إيه اللي اتغير؟ (اختياري)",
  "performance.goals.checkInNotePlaceholder": "إنجاز، عائق، الخطوة الجاية…",
  "performance.goals.checkInInvalid": "اكتب رقم لكل نتيجة رئيسية (ونسبة تقدم من ٠ إلى ١٠٠).",
  "performance.goals.previewHint": "التقدم هو متوسط النتائج الرئيسية، كل واحدة من بدايتها لهدفها.",
  "performance.goals.status.on_track": "على المسار",
  "performance.goals.status.at_risk": "معرّض للتأخير",
  "performance.goals.status.off_track": "متأخر",
  "performance.goals.status.done": "تحقق",
  "performance.goals.status.dropped": "اتلغى",
  "performance.goals.visibility.public": "عام",
  "performance.goals.visibility.private": "خاص",
  "performance.goals.visibilityHint.public": "كل الفريق يقدر يشوفه.",
  "performance.goals.visibilityHint.private": "أنت ومديرك والموارد البشرية بس.",
  "performance.goals.history.title": "تحديثات التقدم",
  "performance.goals.history.empty.title": "مفيش تحديثات لسه",
  "performance.goals.history.empty.body": "كل تحديث للتقدم هيظهر هنا مع ملاحظته.",
  "performance.goals.history.progress": "تم إنجاز {percent}",
  "performance.goals.form.newTitle": "هدف جديد",
  "performance.goals.form.editTitle": "تعديل الهدف",
  "performance.goals.form.hint": "خليه محدد، وقيسه بنتائج رئيسية.",
  "performance.goals.form.companyHint": "هدف للشركة كلها. أي حد يقدر يربط أهدافه بيه.",
  "performance.goals.form.title": "الهدف",
  "performance.goals.form.titleRequired": "اكتب الهدف.",
  "performance.goals.form.description": "ليه مهم (اختياري)",
  "performance.goals.form.startsOn": "يبدأ",
  "performance.goals.form.endsOn": "ينتهي",
  "performance.goals.form.parent": "بيدعم",
  "performance.goals.form.parentHint": "اربطه بهدف للشركة أو بهدف من أهدافك.",
  "performance.goals.form.parentNone": "مش مربوط",
  "performance.goals.form.parentSearch": "ابحث في الأهداف",
  "performance.goals.form.parentEmpty": "مفيش أهداف بالاسم ده.",
  "performance.goals.form.visibility": "مين يقدر يشوفه",
  "performance.goals.form.status": "الحالة",
  "performance.goals.form.progress": "التقدم (٪)",
  "performance.goals.form.progressHint": "بيتستخدم طول ما الهدف مالوش نتائج رئيسية.",
  "performance.goals.form.progressRange": "اكتب رقم من ٠ إلى ١٠٠.",
  "performance.goals.form.keyResults": "النتائج الرئيسية",
  "performance.goals.form.keyResultsHint": "إزاي هتعرف إنك وصلت: قيمة البداية، والمستهدف، والوضع الحالي.",
  "performance.goals.form.keyResultNumber": "النتيجة الرئيسية {number}",
  "performance.goals.form.krTitle": "النتيجة الرئيسية {number}",
  "performance.goals.form.start": "البداية",
  "performance.goals.form.target": "المستهدف",
  "performance.goals.form.current": "الحالي",
  "performance.goals.form.unit": "الوحدة",
  "performance.goals.form.krPreview": "التقدم: {percent}",
  "performance.goals.form.krIncomplete": "اكتب الأرقام عشان تشوف التقدم.",
  "performance.goals.form.removeKr": "حذف النتيجة الرئيسية {number}",
  "performance.goals.form.addKr": "إضافة نتيجة رئيسية",
  "performance.goals.form.create": "إضافة الهدف",
  "performance.goals.form.save": "حفظ الهدف",
  "performance.meetings.title": "الاجتماعات الفردية",
  "performance.meetings.hint": "وقت منتظم مع مديرك أو فريقك: نقاط نقاش مشتركة، ومهام متفق عليها، وملاحظات.",
  "performance.meetings.schedule": "تحديد موعد",
  "performance.meetings.loadError": "معرفناش نحمّل اجتماعاتك الفردية",
  "performance.meetings.empty.title": "مفيش اجتماعات فردية لسه",
  "performance.meetings.empty.body": "حدد موعد مع مديرك أو حد من فريقك.",
  "performance.meetings.empty.noTeam": "الاجتماعات الفردية بتكون بين المدير وحد من فريقه. لما ملفك يكون فيه مدير أو فريق، هتقدر تحدد موعد.",
  "performance.meetings.upcoming": "القادمة",
  "performance.meetings.past": "السابقة",
  "performance.meetings.with": "اجتماع فردي مع {name}",
  "performance.meetings.relation.manager": "مديرك",
  "performance.meetings.relation.report": "من فريقك",
  "performance.meetings.back": "كل الاجتماعات الفردية",
  "performance.meetings.scheduleTitle": "تحديد اجتماع فردي",
  "performance.meetings.scheduleHint": "مع مديرك أو حد من فريقك.",
  "performance.meetings.withLabel": "مع",
  "performance.meetings.option.manager": "{name} (مديرك)",
  "performance.meetings.option.report": "{name} (من فريقك)",
  "performance.meetings.whenLabel": "التاريخ والوقت",
  "performance.meetings.whenRequired": "اختار التاريخ والوقت.",
  "performance.meetings.scheduled": "تم تحديد الاجتماع الفردي.",
  "performance.meetings.status.scheduled": "مجدول",
  "performance.meetings.status.done": "تم",
  "performance.meetings.status.cancelled": "اتلغى",
  "performance.meeting.agenda": "نقاط النقاش",
  "performance.meeting.agendaHint": "أي حد فيكم يقدر يضيف اللي عايز يتكلم فيه.",
  "performance.meeting.noPoints": "مفيش نقاط نقاش لسه.",
  "performance.meeting.newPoint": "أضف نقطة نقاش",
  "performance.meeting.actions": "المهام المتفق عليها",
  "performance.meeting.actionsHint": "مين هيعمل إيه. المهام اللي لسه مفتوحة بتنتقل للاجتماع الجاي.",
  "performance.meeting.noActions": "مفيش مهام لسه.",
  "performance.meeting.newAction": "أضف مهمة",
  "performance.meeting.assignee": "مين هيعملها",
  "performance.meeting.noAssignee": "محدش لسه",
  "performance.meeting.add": "إضافة",
  "performance.meeting.addedBy": "أضافها {name}",
  "performance.meeting.assignedTo": "{name}",
  "performance.meeting.remove": "حذف «{title}»",
  "performance.meeting.carried": "لسه مفتوحة من اجتماعات سابقة",
  "performance.meeting.sharedNotes": "الملاحظات المشتركة",
  "performance.meeting.sharedHint": "أنت و{name} بتشوفوا الملاحظات دي.",
  "performance.meeting.sharedPlaceholder": "ملاحظات من كلامكم…",
  "performance.meeting.conflictTitle": "الملاحظات اتغيرت",
  "performance.meeting.conflictBody": "{name} حفظ الملاحظات المشتركة في نفس الوقت. انسخ اللي عايز تحتفظ بيه، وبعدين اعمل تحديث عشان تشوف تعديلاته.",
  "performance.meeting.privateNotes": "ملاحظات خاصة",
  "performance.meeting.privateHint": "أنت بس اللي تقدر تشوفها. {name} عمره ما هيشوفها، ولا الموارد البشرية.",
  "performance.meeting.privatePlaceholder": "ملاحظاتك الشخصية للاجتماع ده…",
  "performance.meeting.privateUpdated": "آخر حفظ {date}",
  "performance.meeting.markDone": "تم الاجتماع",
  "performance.meeting.markedDone": "تم تسجيل الاجتماع.",
  "performance.meeting.reschedule": "تغيير الموعد",
  "performance.meeting.rescheduleTitle": "تغيير موعد الاجتماع",
  "performance.meeting.rescheduled": "تم تغيير الموعد.",
  "performance.meeting.cancel": "إلغاء الاجتماع",
  "performance.meeting.cancelTitle": "تلغي الاجتماع ده؟",
  "performance.meeting.cancelBody": "نقاط النقاش والمهام والملاحظات هتفضل موجودة، وتقدر تفتحه تاني بعدين.",
  "performance.meeting.cancelConfirm": "إلغاء الاجتماع",
  "performance.meeting.reopen": "إعادة فتح",
  "performance.meeting.reopened": "تمت إعادة فتح الاجتماع.",
  "performance.feedback.title": "الآراء والإشادات",
  "performance.feedback.hint": "اشكر زمايلك قدام الكل، أو ابعت ملاحظة خاصة، أو اطلب رأي حد.",
  "performance.feedback.give": "إرسال رأي",
  "performance.feedback.ask": "طلب رأي",
  "performance.feedback.viewLabel": "أنهي آراء",
  "performance.feedback.view.received": "اللي وصلني",
  "performance.feedback.view.given": "اللي أرسلته",
  "performance.feedback.view.wall": "حائط الإشادات",
  "performance.feedback.view.requests": "طلبات الرأي",
  "performance.feedback.loadError": "معرفناش نحمّل الآراء",
  "performance.feedback.empty.received.title": "مفيش آراء وصلتك لسه",
  "performance.feedback.empty.received.body": "الإشادات والملاحظات الخاصة من زمايلك هتظهر هنا.",
  "performance.feedback.empty.given.title": "لسه ما أرسلتش آراء",
  "performance.feedback.empty.given.body": "كلمة شكر صغيرة بتفرق كتير.",
  "performance.feedback.empty.wall.title": "حائط الإشادات فاضي",
  "performance.feedback.empty.wall.body": "كن أول واحد يشكر زميل قدام الكل.",
  "performance.feedback.to": "إلى",
  "performance.feedback.kind.praise": "إشادة",
  "performance.feedback.kind.private": "ملاحظة خاصة",
  "performance.feedback.kind.requested": "رد على طلب رأي",
  "performance.feedback.kindLabel": "النوع",
  "performance.feedback.kindHint.praise": "على حائط الإشادات: الكل هيشوفها.",
  "performance.feedback.kindHint.private": "هو ومديره والموارد البشرية بس اللي يقروها.",
  "performance.feedback.giveTitle": "إرسال رأي",
  "performance.feedback.giveHint": "خليك محدد: عمل إيه، وليه ده فرق.",
  "performance.feedback.recipient": "إلى",
  "performance.feedback.recipientPlaceholder": "اختار زميل",
  "performance.feedback.recipientRequired": "اختار الرأي لمين.",
  "performance.feedback.body": "الرسالة",
  "performance.feedback.bodyRequired": "اكتب رسالة.",
  "performance.feedback.value": "قيمة من قيم الشركة (اختياري)",
  "performance.feedback.valueHint": "قيمة بتظهر في الموقف ده، زي «المسؤولية».",
  "performance.feedback.send": "إرسال",
  "performance.feedback.sent.praise": "تم نشر الإشادة على الحائط.",
  "performance.feedback.sent.private": "تم إرسال الملاحظة الخاصة.",
  "performance.feedback.askTitle": "طلب رأي",
  "performance.feedback.askHint": "اطلب رأي زمايلك فيك، أو لو مدير، في حد من فريقك.",
  "performance.feedback.subject": "عن",
  "performance.feedback.aboutMe": "أنا",
  "performance.feedback.reviewers": "مين تسأل",
  "performance.feedback.reviewersPlaceholder": "اختار زمايل",
  "performance.feedback.reviewersFull": "{count, plural, other {تقدر تختار لحد # أشخاص.}}",
  "performance.feedback.question": "سؤالك",
  "performance.feedback.questionPlaceholder": "مثلًا: إيه اللي أكمل فيه، وإيه اللي أغيره؟",
  "performance.feedback.questionRequired": "اكتب سؤال من {min} حروف على الأقل.",
  "performance.feedback.dueOn": "الرد قبل (اختياري)",
  "performance.feedback.requested": "{count, plural, zero {لم يُرسل أي طلب.} one {تم إرسال الطلب.} two {تم إرسال طلبين.} few {تم إرسال # طلبات.} many {تم إرسال # طلبًا.} other {تم إرسال # طلب.}}",
  "performance.feedback.requestsLoadError": "معرفناش نحمّل طلبات الرأي",
  "performance.feedback.requestsEmpty.title": "مفيش طلبات رأي",
  "performance.feedback.requestsEmpty.body": "الطلبات اللي بتبعتها، واللي مستنية ردك، هتظهر هنا.",
  "performance.feedback.waitingForYou": "مستنية ردك",
  "performance.feedback.nothingWaiting": "مفيش حاجة مستنياك.",
  "performance.feedback.youAsked": "طلبات أرسلتها",
  "performance.feedback.askedYouAbout": "بيسألك عن {name}",
  "performance.feedback.askedAbout": "اتسأل عن {name}",
  "performance.feedback.requestStatus.open": "في الانتظار",
  "performance.feedback.requestStatus.answered": "تم الرد",
  "performance.feedback.requestStatus.declined": "اعتذر",
  "performance.feedback.answer": "رد",
  "performance.feedback.decline": "اعتذار",
  "performance.feedback.answerTitle": "رأيك في {name}",
  "performance.feedback.answerHint": "{name} هيقرأ ردك، وكمان {actor} اللي طلب الرأي.",
  "performance.feedback.yourAnswer": "ردك",
  "performance.feedback.answered": "شكرًا، رأيك اتبعت.",
  "performance.feedback.declineTitle": "تعتذر عن الطلب ده؟",
  "performance.feedback.declineBody": "{name} هيعرف إنك اعتذرت.",
  "performance.feedback.declined": "تم الاعتذار عن الطلب.",
  "performance.team.cycles": "تقييمات فريقك",
  "performance.team.cyclesHint": "وصلت تقييمات كل واحد من فريقك لفين في كل دورة، ونتايجهم.",
  "performance.team.loadError": "معرفناش نحمّل دورات فريقك",
  "performance.team.cycleError": "الدورة دي ما اتحملتش. جرّب تاني بعد شوية.",
  "performance.team.noCycles.title": "مفيش دورات تقييم لفريقك",
  "performance.team.noCycles.body": "لما الموارد البشرية تطلق دورة فيها حد من فريقك، هتظهر هنا.",
  "performance.team.goals": "أهداف الفريق",
  "performance.team.goalsHint": "أهداف فريقك وتقدمهم.",
  "performance.team.noGoals.title": "مفيش أهداف للفريق لسه",
  "performance.team.noGoals.body": "الأهداف اللي فريقك بيحطها هتظهر هنا.",
  "performance.team.openResults": "النتائج",
  "performance.team.resultsOf": "الخاصة بـ{name}",
  "performance.team.back": "فريقي",
  "performance.hub.nav": "أقسام الأداء",
  "performance.hub.cycles": "دورات التقييم",
  "performance.hub.templates": "نماذج التقييم",
  "performance.cycles.title": "دورات التقييم",
  "performance.cycles.hint": "كل دورة بتطلب تقييم ذاتي وتقييم المدير وتقييم الزملاء وتقييم المرؤوسين للمدير على نموذج واحد، وبعدين بتعدي على المعايرة قبل نشر النتائج.",
  "performance.cycles.new": "دورة جديدة",
  "performance.cycles.loadError": "معرفناش نحمّل دورات التقييم",
  "performance.cycles.empty.title": "مفيش دورات تقييم لسه",
  "performance.cycles.empty.body": "اعمل دورة، وضيف الناس اللي هيتقيّموا، وبعدين أطلقها.",
  "performance.cycles.column.name": "الدورة",
  "performance.cycles.column.period": "الفترة",
  "performance.cycles.column.includes": "التقييمات",
  "performance.cycles.column.status": "الحالة",
  "performance.cycles.back": "كل الدورات",
  "performance.cycles.edit": "تعديل البيانات",
  "performance.cycles.newTitle": "دورة تقييم جديدة",
  "performance.cycles.editTitle": "تعديل الدورة",
  "performance.cycles.formHint": "بتبدأ كمسودة: مفيش حاجة بتتبعت غير لما تطلقها.",
  "performance.cycles.create": "إنشاء الدورة",
  "performance.cycles.save": "حفظ",
  "performance.cycles.created": "تم إنشاء الدورة. ضيف الناس اللي هيتقيّموا.",
  "performance.cycles.saved": "تم حفظ الدورة.",
  "performance.cycles.noTemplates": "مفيش نموذج تقييم مفعّل لسه. اعمل واحد من «نماذج التقييم» الأول.",
  "performance.cycles.form.name": "الاسم",
  "performance.cycles.form.namePlaceholder": "مثلًا: تقييمات الربع الرابع ٢٠٢٦",
  "performance.cycles.form.nameRequired": "اكتب اسم الدورة.",
  "performance.cycles.form.template": "النموذج",
  "performance.cycles.form.templatePlaceholder": "اختار نموذج",
  "performance.cycles.form.templateRequired": "اختار نموذج.",
  "performance.cycles.form.templateLocked": "مينفعش تغيّر النموذج بعد إطلاق الدورة.",
  "performance.cycles.form.periodStart": "بداية الفترة",
  "performance.cycles.form.periodEnd": "نهاية الفترة",
  "performance.cycles.form.reviewDue": "آخر موعد للتقييمات",
  "performance.cycles.form.dateRequired": "اختار تاريخ.",
  "performance.cycles.form.dueAfterStart": "آخر موعد للتقييمات لازم يكون يوم بداية الفترة أو بعده.",
  "performance.cycles.form.includes": "التقييمات المطلوبة",
  "performance.cycles.form.managerAlways": "المدير دايمًا بيقيّم كل واحد من فريقه.",
  "performance.cycles.form.includesLocked": "التقييمات اتعملت لما الدورة اتطلقت، فمينفعش تغيّر مين بيقيّم مين دلوقتي.",
  "performance.cycles.form.includeSelf": "تقييم ذاتي",
  "performance.cycles.form.includeSelfHint": "كل واحد بيقيّم شغله بنفسه.",
  "performance.cycles.form.includePeer": "تقييم الزملاء",
  "performance.cycles.form.includePeerHint": "زمايل بيتختاروا لكل واحد بيقيّموه؛ وهو بيشوف إجاباتهم من غير أسماء.",
  "performance.cycles.form.includeUpward": "تقييم المرؤوسين للمدير",
  "performance.cycles.form.includeUpwardHint": "الفريق بيقيّم مديره من غير أسماء؛ والمدير بيشوف المتوسطات بس بعد ما ٣ يجاوبوا.",
  "performance.stepper.title": "مراحل الدورة",
  "performance.stepper.state.done": "(تمت)",
  "performance.stepper.state.current": "(المرحلة الحالية)",
  "performance.stepper.state.upcoming": "(لسه)",
  "performance.stepper.explain.draft": "ضيف الناس اللي هيتقيّموا وزمايلهم، وبعدين أطلق الدورة. الإطلاق بيفتح كل التقييمات وبيبعت تنبيه لكل اللي هيقيّموا.",
  "performance.stepper.explain.active": "التقييمات بتتكتب دلوقتي. لما تخلص، اقفل الكتابة وابدأ المعايرة.",
  "performance.stepper.explain.calibration": "الكتابة مقفولة. وازن التقييمات وبعدين انشر النتائج. تقدر تفتح الكتابة تاني لو حد اتأخر.",
  "performance.stepper.explain.published": "الموظفين يقدروا يشوفوا نتائجهم ويأكدوا الاطلاع عليها. اقفل الدورة لما تخلص.",
  "performance.stepper.explain.closed": "الدورة دي مقفولة، ونتائجها هتفضل متاحة للقراءة.",
  "performance.stepper.needPeople": "ضيف شخص واحد على الأقل الأول.",
  "performance.stepper.action.launch": "إطلاق الدورة",
  "performance.stepper.action.calibrate": "قفل الكتابة وبدء المعايرة",
  "performance.stepper.action.reopen": "إعادة فتح الكتابة",
  "performance.stepper.action.publish": "نشر النتائج",
  "performance.stepper.action.close": "قفل الدورة",
  "performance.stepper.confirm.launch.title": "تطلق الدورة دي؟",
  "performance.stepper.confirm.launch.body": "التقييمات هتتفتح لـ{count, plural, zero {مفيش حد} one {شخص واحد} two {شخصين} few {# أشخاص} many {# شخصًا} other {# شخص}} وكل اللي هيقيّموا هيوصلهم تنبيه. مينفعش تغيّر الناس أو النموذج بعد الإطلاق.",
  "performance.stepper.confirm.calibrate.title": "تقفل الكتابة؟",
  "performance.stepper.confirm.calibrate.body": "محدش هيقدر يرسل تقييم تاني. التقييمات اللي لسه ما اتكتبتش هتفضل كده إلا لو فتحت الكتابة تاني.",
  "performance.stepper.confirm.reopen.title": "تفتح الكتابة تاني؟",
  "performance.stepper.confirm.reopen.body": "اللي هيقيّموا يقدروا يرسلوا تاني لحد ما تقفل الكتابة. نتائج المعايرة هتفضل زي ما هي.",
  "performance.stepper.confirm.publish.title": "تنشر النتائج؟",
  "performance.stepper.confirm.publish.body": "كل موظف هيقدر يقرأ تقييم مديره، وآراء زمايله من غير أسماء، ونتيجته النهائية، وهيتطلب منه يأكد الاطلاع. الخطوة دي مينفعش ترجع فيها.",
  "performance.stepper.confirm.close.title": "تقفل الدورة دي؟",
  "performance.stepper.confirm.close.body": "الدورة هتتقفل. النتائج هتفضل متاحة، ومفيش حاجة تانية هتتغير.",
  "performance.stepper.done.launch": "تم إطلاق الدورة وتنبيه كل اللي هيقيّموا.",
  "performance.stepper.done.calibrate": "تم قفل الكتابة. تقدر تبدأ المعايرة.",
  "performance.stepper.done.reopen": "تمت إعادة فتح الكتابة.",
  "performance.stepper.done.publish": "تم نشر النتائج.",
  "performance.stepper.done.close": "تم قفل الدورة.",
  "performance.participants.title": "الناس في الدورة دي",
  "performance.participants.hint": "اختار مين هيتقيّم. المدير بيتاخد من ملف الموظف وقت الإطلاق.",
  "performance.participants.hintPeers": "اختار مين هيتقيّم والزملاء اللي هيقيّموا كل واحد. المدير بيتاخد من ملف الموظف وقت الإطلاق.",
  "performance.participants.add": "إضافة أشخاص",
  "performance.participants.addPlaceholder": "اختار الناس اللي هيتقيّموا",
  "performance.participants.addChosen": "{count, plural, zero {إضافة} one {إضافة شخص} two {إضافة شخصين} few {إضافة # أشخاص} many {إضافة # شخصًا} other {إضافة # شخص}}",
  "performance.participants.addEveryone": "{count, plural, zero {الكل موجود} other {إضافة الكل (#)}}",
  "performance.participants.saved": "تم حفظ الأشخاص.",
  "performance.participants.empty.title": "مفيش حد في الدورة لسه",
  "performance.participants.empty.body": "ضيف الناس اللي هيتقيّموا من فوق، أو الكل مرة واحدة.",
  "performance.participants.noManager": "مفيش مدير في الملف",
  "performance.participants.noPeers": "مفيش زملاء لسه",
  "performance.participants.peers": "{count, plural, zero {اختيار الزملاء} one {زميل واحد} two {زميلين} few {# زملاء} many {# زميلًا} other {# زميل}}",
  "performance.participants.remove": "شيل {name} من الدورة",
  "performance.peers.title": "زملاء {name}",
  "performance.peers.hint": "لحد عشرة زمايل يعرفوا شغله. طلبات التقييم بتتبعت لهم وقت الإطلاق.",
  "performance.peers.liveHint": "الزملاء الجداد هيتطلب منهم التقييم فورًا. اللي أرسل تقييمه بيفضل؛ وشيل زميل بيلغي تقييمه بس لو لسه ما كتبهوش.",
  "performance.peers.label": "الزملاء",
  "performance.peers.placeholder": "اختار زمايل",
  "performance.peers.save": "حفظ الزملاء",
  "performance.peers.saved": "تم حفظ الزملاء.",
  "performance.progress.title": "تقدم التقييمات",
  "performance.progress.hint": "مين أرسل، ومين لسه، ومين اعتذر. تقييمات المرؤوسين للمدير بتظهر كعدد بس.",
  "performance.progress.caption": "تقدم التقييمات لكل شخص",
  "performance.progress.person": "الموظف",
  "performance.progress.reviews": "التقييمات",
  "performance.progress.count": "{done} من {total}",
  "performance.progress.manager": "تقييم المدير",
  "performance.progress.final": "النتيجة النهائية",
  "performance.progress.acknowledged": "تم الاطلاع",
  "performance.progress.notYet": "لسه",
  "performance.progress.actions": "إجراءات",
  "performance.progress.peers": "الزملاء",
  "performance.progress.none": "مفيش تقييمات",
  "performance.progress.reviewer": "{name} · {label}",
  "performance.progress.iconLabel": "{label}: {status}",
  "performance.progress.upward": "المرؤوسين: أرسل {done} من {total}",
  "performance.calibration.title": "المعايرة",
  "performance.calibration.hint": "وازن التقييمات على مستوى الفريق. اسحب الشخص لتقييم تاني أو استخدم «تغيير التقييم». لازم تكتب سبب لو النتيجة مختلفة عن تقييم المدير.",
  "performance.calibration.distribution": "توزيع التقييمات",
  "performance.calibration.viewLabel": "العرض",
  "performance.calibration.chart": "رسم بياني",
  "performance.calibration.table": "جدول",
  "performance.calibration.barTooltip": "{label}: {count, plural, zero {مفيش حد} one {شخص واحد} two {شخصين} few {# أشخاص} many {# شخصًا} other {# شخص}}",
  "performance.calibration.rating": "التقييم",
  "performance.calibration.people": "عدد الأشخاص",
  "performance.calibration.emptyBucket": "اسحب حد هنا",
  "performance.calibration.unrated": "من غير تقييم لسه",
  "performance.calibration.unratedHint": "مديرهم لسه ما أرسلش التقييم. حدد النتيجة بنفسك، أو افتح الكتابة تاني.",
  "performance.calibration.calibrated": "تمت المعايرة",
  "performance.calibration.change": "تغيير التقييم",
  "performance.calibration.dragHandle": "انقل {name} لتقييم تاني",
  "performance.calibration.picked": "تم اختيار {name}.",
  "performance.calibration.over": "{name} فوق «{label}».",
  "performance.calibration.dropped": "تم وضع {name} في «{label}».",
  "performance.calibration.cancelled": "تم إلغاء نقل {name}.",
  "performance.calibration.dialogTitle": "معايرة {name}",
  "performance.calibration.dialogHint": "النتيجة اللي هتحددها هتبقى النتيجة النهائية.",
  "performance.calibration.final": "النهائية",
  "performance.calibration.newRating": "النتيجة",
  "performance.calibration.noteRequired": "سبب الاختلاف (مطلوب)",
  "performance.calibration.noteOptional": "ملاحظة (اختياري)",
  "performance.calibration.noteHint": "لازم تكتب سبب لو النتيجة مختلفة عن تقييم المدير ({number}).",
  "performance.calibration.noManagerRating": "مفيش تقييم من المدير لسه، فاكتب سبب النتيجة دي.",
  "performance.calibration.reset": "الرجوع لتقييم المدير",
  "performance.calibration.save": "حفظ النتيجة",
  "performance.calibration.saved": "تم حفظ نتيجة {name}.",
  "performance.calibration.resetDone": "{name} رجع لتقييم المدير.",
  "performance.templates.title": "نماذج التقييم",
  "performance.templates.hint": "الأسئلة اللي الدورة بتسألها، ومين بيتسأل كل سؤال. النموذج اللي بتستخدمه دورة شغالة مينفعش تتغير أسئلته.",
  "performance.templates.new": "نموذج جديد",
  "performance.templates.loadError": "معرفناش نحمّل النماذج",
  "performance.templates.empty.title": "مفيش نماذج لسه",
  "performance.templates.empty.body": "اكتب أسئلة التقييم بالعربي والإنجليزي.",
  "performance.templates.inactive": "متوقف",
  "performance.templates.inUse": "مستخدم: الأسئلة مقفولة",
  "performance.templates.questionCount": "{count, plural, zero {مفيش أسئلة} one {سؤال واحد} two {سؤالين} few {# أسئلة} many {# سؤالًا} other {# سؤال}}",
  "performance.templates.edit": "تعديل",
  "performance.templates.newTitle": "نموذج جديد",
  "performance.templates.editTitle": "تعديل النموذج",
  "performance.templates.formHint": "أسئلة التقييم بمقياس من ١ لـ٥ مع تعليق اختياري؛ والأسئلة النصية إجابتها مكتوبة.",
  "performance.templates.name": "الاسم",
  "performance.templates.nameRequired": "اكتب اسم النموذج.",
  "performance.templates.description": "الوصف (اختياري)",
  "performance.templates.active": "مفعّل",
  "performance.templates.activeHint": "بيظهر لما تعمل دورة جديدة.",
  "performance.templates.lockedTitle": "الأسئلة مقفولة",
  "performance.templates.lockedBody": "فيه دورة شغالة بتستخدم النموذج ده، فمينفعش أسئلته تتغير. لسه تقدر تغيّر اسمه أو توقفه.",
  "performance.templates.questions": "الأسئلة",
  "performance.templates.questionNumber": "السؤال {number}",
  "performance.templates.moveUp": "حرّك السؤال {number} لفوق",
  "performance.templates.moveDown": "حرّك السؤال {number} لتحت",
  "performance.templates.remove": "حذف السؤال {number}",
  "performance.templates.promptAr": "السؤال بالعربي",
  "performance.templates.promptEn": "السؤال بالإنجليزي",
  "performance.templates.kind": "النوع",
  "performance.templates.kinds.rating": "تقييم (١–٥)",
  "performance.templates.kinds.text": "إجابة مكتوبة",
  "performance.templates.weight": "الوزن",
  "performance.templates.competency": "الكفاءة (اختياري)",
  "performance.templates.required": "مطلوب",
  "performance.templates.askedOf": "بيتسأل في:",
  "performance.templates.audience.forSelf": "الذاتي",
  "performance.templates.audience.forManager": "المدير",
  "performance.templates.audience.forPeer": "الزملاء",
  "performance.templates.audience.forUpward": "المرؤوسين",
  "performance.templates.addQuestion": "إضافة سؤال",
  "performance.templates.fixErrors": "اكتب السؤال باللغتين، ووزن أكبر من صفر (لحد ١٠)، واختار تقييم واحد على الأقل لكل سؤال.",
  "performance.templates.save": "حفظ النموذج",
  "performance.templates.created": "تم إنشاء النموذج.",
  "performance.templates.saved": "تم حفظ النموذج.",
  "performance.errors.templateNotFound": "النموذج ده مبقاش موجود.",
  "performance.errors.templateInUse": "فيه دورة شغالة بتستخدم النموذج ده، فمينفعش أسئلته تتغير.",
  "performance.errors.cycleNotFound": "دورة التقييم دي مبقتش موجودة.",
  "performance.errors.cycleState": "الخطوة دي مش مناسبة لمرحلة الدورة دلوقتي. اعمل تحديث وشوف هي فين.",
  "performance.errors.participantNotFound": "معرفناش نلاقي تقييم الشخص ده.",
  "performance.errors.reviewNotFound": "التقييم ده مبقاش موجود.",
  "performance.errors.reviewClosed": "التقييم ده اتبعت أو اتعمل عنه اعتذار، أو الدورة عدّت المرحلة دي.",
  "performance.errors.answersIncomplete": "قيّم كل الأسئلة المطلوبة قبل الإرسال.",
  "performance.errors.goalNotFound": "الهدف ده مبقاش موجود، أو مينفعش تعدّله.",
  "performance.errors.goalLoop": "الهدف مينفعش يدعم نفسه أو هدف تابع له.",
  "performance.errors.meetingNotFound": "الاجتماع الفردي ده مبقاش موجود.",
  "performance.errors.feedbackNotFound": "الطلب ده اتردّ عليه أو اتعمل عنه اعتذار.",
  "performance.errors.feedbackToSelf": "الرأي بيتبعت لحد تاني، مش لنفسك.",
  "performance.errors.noParticipants": "ضيف الناس اللي هيتقيّموا قبل الإطلاق.",
  "performance.errors.needsRecord": "كل اللي في الدورة لازم يكون ليهم ملف في الموارد البشرية.",
  "performance.errors.cycleDates": "نهاية الفترة لازم تكون بعد بدايتها.",
  "performance.errors.goalDates": "نهاية الهدف لازم تكون بعد بدايته.",
  "performance.errors.noteRequired": "اكتب سبب اختلاف النتيجة عن تقييم المدير.",
  "performance.errors.notManagerPair": "الاجتماعات الفردية بتكون بين المدير وحد من فريقه بس.",
  "performance.errors.subjectNotReport": "اسأل عن نفسك، أو عن حد من فريقك.",
  "performance.errors.noReviewers": "اختار زميل واحد على الأقل.",
  "performance.errors.recipient": "اختار حد من الفريق.",
  "performance.errors.gone": "ممكن يكون اتشال، أو مش مشترك معاك."
}
